import { Range } from '@root/types';

interface IRangeValues {
  range: Range;
  minVal: number;
  maxVal: number;
}

const getRange = (score: number): Range => {
  const ranges: IRangeValues[] = [
    { range: '0-19', minVal: 0, maxVal: 19 },
    { range: '20-39', minVal: 20, maxVal: 39 },
    { range: '40-59', minVal: 40, maxVal: 59 },
    { range: '60-79', minVal: 60, maxVal: 79 },
    { range: '80-100', minVal: 80, maxVal: 100 },
  ];
  let result;
  ranges.forEach((value) => {
    if (between(score, value.minVal, value.maxVal)) {
      result = value.range;
    }
  });
  if (!result) {
    throw new Error('Failed to calculate score range.');
  }

  return result;
};

const between = (x: number, min: number, max: number) => {
  return x >= min && x <= max;
};

export default getRange;
